import { z } from "zod";

export const deletionScheduledSchema = z.object({
  scheduledAt: z.string().datetime(),
});

export type DeletionScheduledDto = z.infer<typeof deletionScheduledSchema>;
